import axios from 'axios';
import { CD_SISTEMA } from '@/constants';
const BASE_URL = `${process.env.VUE_APP_PESQUISA_SATISFACAO_BACKEND}/api`;

class PesquisaSatisfacaoService {
  getWidgetCode() {
    return axios
      .get(`${BASE_URL}/pesquisa-atual?cdSistema=${CD_SISTEMA}`)
      .then((response) => {
        if (response.data?.status === 200 && response.data?.script) {
          return response.data.script;
        }
        return null;
      });
  }
}

export default new PesquisaSatisfacaoService();
